import { IOeDataOrganizationCorporateDTO, IOeDataOrganizationDTO } from '../oe-data-organizations.dao';

const ORGANIZATION_NAMES = ['Acme Holdings', 'Blue Harbor Advisors', 'Copper Ridge Securities', 'Evergreen Pension Fund', 'Granite Peak Investments', 'Lakeside Asset Management', 'Meridian Group', 'Northwind Partners', 'Summit Bancorp', 'Zebra Capital'];
const ORGANIZATION_TYPES = ['Corporate', 'Investor', 'Bank', 'Broker'];
const HQ_LOCATIONS = [['London', 'United Kingdom'], ['New York', 'United States'], ['Frankfurt', 'Germany'], ['Tokyo', 'Japan']];
const SECTORS = [['Financials', 'Banks'], ['Technology', 'Software'], ['Energy', 'Oil & Gas'], ['Health Care', 'Pharmaceuticals']];
const MOCK_ORGANIZATIONS_COUNT = 650;
const ORGANIZATIONS_PER_NAME = Math.ceil(MOCK_ORGANIZATIONS_COUNT / ORGANIZATION_NAMES.length);

const getCorporate = (index: number): IOeDataOrganizationCorporateDTO => {
    const [sector, industry] = SECTORS[index % SECTORS.length];

    return {
        ticker: `OE${index}`,
        exchange: index % 2 ? 'NYSE' : 'LSE',
        isin: `US${String(index).padStart(10, '0')}`,
        marketCap: (index + 1) * 1000000,
        marketCapCurrency: index % 2 ? 'USD' : 'GBP',
        sector: sector,
        industry: industry,
        fiscalYearEnd: '12-31',
        irWebsite: `https://ir.organization-${index}.com`,
    };
};

const getOrganization = (index: number): IOeDataOrganizationDTO => {
    const name = `${ORGANIZATION_NAMES[Math.floor(index / ORGANIZATIONS_PER_NAME)]} ${String(index % ORGANIZATIONS_PER_NAME + 1).padStart(3, '0')}`;
    const isBare = index % 7 === 0;
    const [hqCity, hqCountry] = HQ_LOCATIONS[index % HQ_LOCATIONS.length];

    return {
        organizationId: index + 1,
        name: name,
        shortName: name.split(' ')[0],
        organizationType: ORGANIZATION_TYPES[index % ORGANIZATION_TYPES.length],
        parentOrganizationName: isBare ? null : ORGANIZATION_NAMES[(index + 1) % ORGANIZATION_NAMES.length],
        hqCity: isBare ? null : hqCity,
        hqCountry: isBare ? null : hqCountry,
        website: `https://organization-${index}.com`,
        notes: index % 3 ? null : 'Mock organization',
        createdAt: '2026-01-15T08:30:00Z',
        updatedAt: '2026-09-30T17:45:00Z',
        activeStatus: index % 5 ? 'Active' : 'Inactive',
        corporate: isBare ? null : getCorporate(index),
    };
};

export const OE_DATA_ORGANIZATIONS_MOCK: IOeDataOrganizationDTO[] = Array.from({ length: MOCK_ORGANIZATIONS_COUNT }, (_, index) => getOrganization(index));
